import { EnumOption } from './enum-option';

export const MatterPERMRole = {
  CurrentJob: 0,
  FutureJob: 1,
};

export const MatterPERMRoleList: EnumOption[] = [
  { value: MatterPERMRole.CurrentJob, label: 'Current Job' },
  { value: MatterPERMRole.FutureJob, label: 'Future Job' },
];
